export default __webpack_public_path__ + "fd55ab6187908acf2c0ec37625439aa5.woff2";